import { SvgIconProps, SvgIcon } from '@material-ui/core';

/**
 * "AI brain" icon — an organic brain hemisphere on the left with a circuit
 * network branching to the right, used for the AI Platforms docs entry.
 *
 * Based on the Lucide "brain-circuit" glyph (ISC License, https://lucide.dev),
 * with local enhancements for legibility at sidebar size (24px): heavier
 * circuit traces and solid, filled connection nodes in place of Lucide's
 * hollow 0.5px dots, which otherwise disappear when rendered small.
 *
 * Provided as a custom SVG because no brain glyph ships in this app's pinned
 * @material-ui/icons v4.11.3 — same pattern as RunwayIcon / SlackIcon.
 */
export const BrainIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    {/* brain outline */}
    <path
      fill="none"
      strokeWidth={1.9}
      d="M12 5a3 3 0 1 0-5.997.125a4 4 0 0 0-2.526 5.77a4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"
    />
    {/* inner gyri folds */}
    <path
      fill="none"
      strokeWidth={1.7}
      d="M9 13a4.5 4.5 0 0 0 3-4M6.003 5.125A3 3 0 0 0 6.401 6.5m-2.924 4.396a4 4 0 0 1 .585-.396M6 18a4 4 0 0 1-1.967-.516"
    />
    {/* circuit traces */}
    <path fill="none" strokeWidth={2.4} d="M12 13h4m-4 5h6a2 2 0 0 1 2 2v1M12 8h8m-4 0V5a2 2 0 0 1 2-2" />
    {/* circuit nodes */}
    <circle cx={16} cy={13} r={1.15} fill="currentColor" stroke="none" />
    <circle cx={18} cy={3} r={1.15} fill="currentColor" stroke="none" />
    <circle cx={20} cy={21} r={1.15} fill="currentColor" stroke="none" />
    <circle cx={20} cy={8} r={1.15} fill="currentColor" stroke="none" />
  </SvgIcon>
);
